import { hasParents, hasElement } from './element';
import { ElementIds, Parents, Elements, Position } from '../types';

export function getChildrenOfParents(elements: Elements, [father, mother]: Parents, id: Element['id']): ElementIds {
  const element = elements[id];
  if (!hasElement(elements, id) || !hasParents(element)) {
    return [];
  }

  const count = element.parents.filter(([p1, p2]) => father === p1 && mother === p2).length;
  if (count === 0) return [];
  if (count === 1) return [id];

  return Array(count).fill(id);
}

export function getPossibleChildren(elements: Elements, [fatherId, motherId]: Parents) {
  if (!hasElement(elements, fatherId) || !hasElement(elements, motherId)) {
    return [];
  }

  const father = elements[fatherId];
  const mother = elements[motherId];

  if (fatherId === motherId) {
    return father.children;
  }

  const possible: ElementIds = [];
  father.children.forEach((id) => {
    if (!mother.children.includes(id)) return;
    if (possible.includes(id)) return;

    possible.push(id);
  });

  return possible;
}

export function mixParents(elements: Elements, parents: Parents): ElementIds {
  let children: ElementIds = [];

  const ids = getPossibleChildren(elements, parents);
  const length = ids.length;
  for (let i = 0; i < length; ++i) {
    const list = getChildrenOfParents(elements, parents, ids[i]);
    if (list.length) {
      children = children.concat(list);
    }
  }

  return children;
}

const SPACING_FACTOR = 0.35;
export function calcChildrenPositions(
  [fatherPosition, motherPosition]: Position[],
  width: number,
  count: number,
): Position[] {
  const childPosition = (no: number) => {
    // direction factor of line of parents
    const a = (fatherPosition.y - motherPosition.y) /
              (fatherPosition.x - motherPosition.x);

    // distance between children
    const translation = width * SPACING_FACTOR;

    const middlePoint = {
      x: (fatherPosition.x + motherPosition.x) / 2,
      y: (fatherPosition.y + motherPosition.y) / 2,
    };

    // coordinates of child on normal line to line of parents
    const x = middlePoint.x + (Math.cos(Math.atan(-1 / a)) * no * translation);
    const y = middlePoint.y + (Math.sin(Math.atan(-1 / a)) * no * translation);

    return {
      x: Math.round(x),
      y: Math.round(y),
    };
  };

  const positions = [];
  const n = Math.floor(count / 2);
  for (let i = -n; i <= n; i++) {
    if (i !== 0 || count % 2) {
      positions.push(childPosition(i));
    }
  }

  return positions;
}
